export type TServiceTrackerReducer = Record<
  string,
  'LOADING' | 'SUCCESS' | 'ERROR'
>

export const INITIAL_STATE: TServiceTrackerReducer = {}
